import { render, staticRenderFns } from "./Page10.vue?vue&type=template&id=0feec042&"
import script from "./Page10.vue?vue&type=script&lang=js&"
export * from "./Page10.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports